module.exports = __webpack_public_path__ + "img/nav-icon-text-size_2x.aa4dbc90.svg";